import type { FC } from "react";
import { useId } from "react";

import { displayOutcomeName } from "components/outcomes/helpers";
import { OutcomeType } from "components/server-types";
import { t } from "i18n/i18n";
import { OutcomeChip } from "mds/components/OutcomeChip";

type OutcomeChipListProps = {
  outcomes: OutcomeType[];
  scoreMap?: Record<string, number>;
  getOutcomeUrl: (outcome: OutcomeType) => string;
};

export const OutcomeChipList: FC<OutcomeChipListProps> = ({
  outcomes,
  scoreMap = {},
  getOutcomeUrl,
}) => {
  const headingId = useId();
  return (
    <>
      <h3 className="flex items-center justify-between text-black-tint-40" id={headingId}>
        {t("glossary.outcomes")}
      </h3>
      <ol aria-labelledby={headingId} className="my-2 flex flex-wrap items-center">
        {outcomes.map((outcome) => (
          <li key={outcome.id}>
            <OutcomeChip
              className="mx-2 my-1"
              score={scoreMap[outcome.id] ?? undefined}
              title={displayOutcomeName(outcome)}
              to={getOutcomeUrl(outcome)}
            />
          </li>
        ))}
      </ol>
    </>
  );
};
